module.exports = __webpack_public_path__ + "static/assets/b3a2f0aaa964d2265872d3f32c848001.png";